import styled from 'styled-components';

export const SettlementsWrapper = styled.div``;
export const SettlementsTableWrapper = styled.div`
    width: 100%;
    overflow: auto;
`;
export const SettlementsTitle = styled.h1`
    margin: 12px 0;
`;